<script setup lang="ts">
import FinestCard from '@/components/FinestCard.vue'
import FinestInputNumber from '@/components/FinestInputNumber.vue'
import PropertyStepErrors from '@/components/portfolio/PropertyStepErrors.vue'
import { useI18n } from 'vue-i18n'

defineProps<{
  spaceLabel: string
  errors: string[]
}>()

const spaceSize = defineModel<number | null>('spaceSize', { default: null })
const numberOfUnits = defineModel<number | null>('numberOfUnits', { default: null })

const { t, locale } = useI18n({ useScope: 'local' })
</script>

<template>
  <FinestCard :title="t('title')" icon="pi pi-key">
    <p class="text-ink-2 mb-4 text-sm">{{ t('hint') }}</p>

    <PropertyStepErrors :messages="errors" class="mb-4" />

    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <div>
        <label class="field-label">{{ spaceLabel }}</label>
        <FinestInputNumber v-model="spaceSize" suffix=" m²" :locale="locale" :aria-label="spaceLabel" />
      </div>

      <div>
        <label class="field-label">{{ t('fields.number_of_units') }}</label>
        <FinestInputNumber
          v-model="numberOfUnits"
          :use-grouping="false"
          :locale="locale"
          :aria-label="t('fields.number_of_units')" />
      </div>
    </div>
  </FinestCard>
</template>

<i18n lang="json">
{
  "de": {
    "title": "Einheiten & Miete",
    "hint": "Diese Angaben sind optional – du kannst sie auch später in der Detailansicht ergänzen.",
    "fields": {
      "number_of_units": "Anzahl Einheiten"
    }
  },
  "en": {
    "title": "Units & rent",
    "hint": "These details are optional – you can also add them later in the detail view.",
    "fields": {
      "number_of_units": "Number of units"
    }
  }
}
</i18n>
